module.exports = __webpack_public_path__ + "img/key-words-2.0cb9abc7.png";